// Core
import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { motion, useAnimation } from 'framer-motion';
import { Box, Image, Divider, Button, Grid, Text, Flex, 
    Tooltip, IconButton,
    Checkbox, useBreakpointValue, useColorModeValue } from '@chakra-ui/react';
import { NavLink, Link, useHistory, useLocation } from 'react-router-dom';

// Assets
import { apiService } from 'services/ApiService';
import { ReactComponent as PlusCategoryIcon } from 'assets/svg/show-category-parent.svg';

// Components
import { ArrowCategoryIcon, Info2Icon } from 'components/Icons/Icons';
import Partners from '../../Partners';

const Explore = ({
    isPopular,
    setIsPopular,
    isFeatured,
    setIsFeatured,
    isShop,
    setIsShop,
    nearMe,
    setNearMe,
    mapView
}) => {
    const textColor = useColorModeValue('#0E1633', 'white');
    const ttpTextColor = useColorModeValue('#0E1633', '#E1E1E1');
    const ttpBgColor = useColorModeValue('white', '#0D234D');
    const stateMapStyle = {
        opacity: '0.3',
        pointerEvents: 'none'
    };

    const [collapsedItems, setCollapsedItems] = useState(true); 
    const toggleItems = () => {
        setCollapsedItems(!collapsedItems);
    };

    const responsiveSettings = useBreakpointValue({ base: true, md: false });
    useEffect(() => { setCollapsedItems(responsiveSettings); }, [responsiveSettings]);

    const history = useHistory();
    const updateFilters = (type) => {
        const searchParams = new URLSearchParams(window.location.search);

        if (type === 'popular') {
            setIsPopular(!isPopular);
            if (!isPopular) {
                searchParams.set('sort', 'mostPop');
            } else {
                searchParams.delete('sort');
            }

            searchParams.delete('tops');
            setIsFeatured(false);

            searchParams.delete('shop');  
            setIsShop(false);
        }

        if (type === 'featured') {
            setIsFeatured(!isFeatured);
            if (!isFeatured) {
                searchParams.set('tops', 'featured'); 
            } else {
                searchParams.delete('tops'); 
            }

            searchParams.delete('sort');
            setIsPopular(false);

            searchParams.delete('shop');  
            setIsShop(false);
        }

        if (type === 'shop') {
            setIsShop(!isShop);
            if (!isShop) {
                searchParams.set('shop', 'true'); 
            } else {
                searchParams.delete('shop'); 
            }

            searchParams.delete('tops');
            setIsFeatured(false);

            searchParams.delete('sort');
            setIsPopular(false);
        }

        if (type === 'nearMe') {
            setNearMe(!nearMe);
            if (!nearMe) {
                searchParams.set('nearMe', 'true'); 
            } else {
                searchParams.delete('nearMe'); 
            }
        }

        history.push({ search: searchParams.toString() }); 
    };

    return (
        <>
            <Flex alignItems="center" justifyContent="space-between" pt="10px">
                <Text variant="text-md" color={textColor} fontWeight="500">
                    Explore
                </Text>
                <ArrowCategoryIcon 
                    fontSize="24px"
                    transition="0.2s all"
                    transform={ collapsedItems ? 'rotate(90deg)' : 'rotate(0deg)' } 
                    onClick={toggleItems} />
            </Flex>

            <Box 
                maxH={collapsedItems ? '0px' : 'auto'} 
                transition="0.2s all" 
                sx={{
                    '&::-webkit-scrollbar': { display: 'none' }, 
                    '-ms-overflow-style': 'none', 
                    'scrollbar-width': 'none',
                }}
                overflow="hidden" 
                opacity={ collapsedItems ? '0' : '1'}
                p="24px 12px 0 12px">

                <Box mb="12px" className="ratio-checkbox" style={ mapView ? stateMapStyle : {}}>
                    <Checkbox
                        isChecked={isPopular}
                        onChange={() => updateFilters('popular')}>
                        <Text variant="text-sm" whiteSpace="nowrap" color={textColor} fontWeight="500">
                            Popular Partner
                        </Text>
                    </Checkbox>
                </Box>

                <Box mb="12px" className="ratio-checkbox">
                    <Checkbox
                        isChecked={isFeatured}
                        onChange={() => updateFilters('featured')}>
                        <Text variant="text-sm" whiteSpace="nowrap" color={textColor} fontWeight="500">
                            Featured Partner
                        </Text>
                    </Checkbox>
                </Box>

                <Box mb="6px" className="ratio-checkbox">
                    <Checkbox
                        isChecked={isShop}
                        onChange={() => updateFilters('shop')}>
                        <Text variant="text-sm" whiteSpace="nowrap" color={textColor} fontWeight="500">
                            Stores
                        </Text>
                    </Checkbox>
                </Box>

                <Box mb="12px" style={ mapView ? stateMapStyle : {}}>
                    <Checkbox
                        isChecked={nearMe}
                        onChange={() => updateFilters('nearMe')}>
                        <Flex gap="2px" alignItems="center">
                            <Text variant="text-sm" whiteSpace="nowrap" color={textColor} fontWeight="500">Near me</Text>
                            <Tooltip 
                                label="Shows partners near you within a 2 km radius" 
                                bg={ttpBgColor}
                                color={ttpTextColor}
                                fontWeight="400"
                                fontSize="12px"
                                borderRadius="4px"
                                maxW="198px"
                                padding="4px 8px"
                                aria-label="tooltip" 
                                hasArrow>
                                <IconButton
                                    icon={<Info2Icon fontSize="18px" />}
                                    variant="ghost-sx"
                                    size="sm"
                                    aria-label=""
                                  />
                            </Tooltip>
                        </Flex>
                    </Checkbox>
                </Box>
            </Box>

        </>
    );
};


export default Explore;